import classNames from 'classnames';
import styles from './container.module.less';
export function Container({ className = '', children, ...props }) {
  return (
    <div {...props} className={classNames(styles.container, className)}>
      {children}
    </div>
  );
}
